import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=6f149572&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=ts"
export * from "./NotificationList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=6f149572&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f149572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f149572')) {
      api.createRecord('6f149572', component.options)
    } else {
      api.reload('6f149572', component.options)
    }
    module.hot.accept("./NotificationList.vue?vue&type=template&id=6f149572&scoped=true", function () {
      api.rerender('6f149572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/NotificationList.vue"
export default component.exports